import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from "react-router-dom";
import { Navbar, Nav, Container, NavDropdown, Image } from "react-bootstrap";
import { signOut, fetchAuthSession } from 'aws-amplify/auth';

import './CustomNavbar.css';
import loadLogo from '../../../static/primapowerlogo.png';

// Icons
import { 
  FaNetworkWired,
  FaHeartbeat,
  FaMicrochip,
  FaChartLine,
  FaUserCircle,
  FaUsersCog
} from "react-icons/fa";

const CustomNavbar = () => {

  const [role, setRole] = useState(null);   // "admin", "internal", "customer"
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  // ----------------------------------------
  // FETCH USER ROLE
  // ----------------------------------------
  const getUserRole = async () => {
    try {
      const session = await fetchAuthSession();
      const groups = session.tokens.idToken.payload['cognito:groups'] || [];

      if (groups.includes("admins")) setRole("admin");
      else if (groups.includes("internals")) setRole("internal");
      else if (groups.includes("customers")) setRole("customer");

    } catch (error) {
      console.error("Error fetching user groups:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserRole();
  }, []);

  // ----------------------------------------
  // SIGN OUT
  // ----------------------------------------
  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.log('Error signing out:', error);
    }
  };

  // ----------------------------------------
  // MENU SECTIONS WITH ICONS
  // ----------------------------------------
  const sectionsInternal = [
    {
      title: (
        <>
          <FaNetworkWired className="me-2" />
          Connessione
        </>
      ),
      items: [
        { to: '/analisi-connessione-macchine', label: 'Overview invio ALLARMI' },
        { to: '/analisi-connessione-macchine-mdc', label: 'Overview invio MDC' },
        { to: '/analisi-connessione-macchine-trigger', label: 'Overview invio TRIGGER' }
      ]
    },
    {
      title: (
        <>
          <FaHeartbeat className="me-2" />
          Diagnostica
        </>
      ),
      items: [
        { to: '/analisi-stato-macchine', label: 'Stato Macchine 30gg' },
        { to: '/analisi-errore-driver', label: 'Confronto Errori Macchina' },
        { to: '/analisi-errore-statistica', label: 'Statistica Errori Macchina' }
      ]
    },
    {
      title: (
        <>
          <FaMicrochip className="me-2" />
          Sensoristica
        </>
      ),
      items: [
        { to: '/analisi-segnali-sensori', label: 'Analisi sensoristica' }
      ]
    },
    {
      title: (
        <>
          <FaChartLine className="me-2" />
          Produzione
        </>
      ),
      items: [
        { to: '/analisi-produzione', label: 'Produzione globale' },
        { to: '/analisi-produzione-cliente', label: 'Produzione cliente' },
        { to: '/analisi-tempo-vetrino-cliente', label: 'Tempi apertura vetrino' },
      ]
    },
    {
      title: (
        <>
          <FaNetworkWired className="me-2" />
          Sistemi 2D
        </>
      ),
      items: [
        { to: '/analisi-connessione-sistemi', label: 'Overview' },
      ]
    }
  ];

  const sectionsCustomer = [
    {
      title: (
        <>
          <FaUsersCog className="me-2" />
          Overview Cliente
        </>
      ),
      items: [
        { to: '/analisi-overview-cliente', label: 'Dashboard cliente' }
      ]
    }
  ];

  // Helper render
  const renderSection = (section) => (
    <NavDropdown key={section.title} title={section.title}>
      {section.items.map((item, i) => (
        <NavDropdown.Item key={i} as={NavLink} to={item.to}>
          {item.label}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );

  // ----------------------------------------
  // RENDER
  // ----------------------------------------
  if (loading) return null;

  return (
    <Navbar collapseOnSelect expand="lg" className="my-navbar" data-bs-theme="dark">
      <Container>

        {/* LOGO */}
        <Navbar.Brand as={NavLink} to='/' className="d-flex align-items-center">
          <Image src={loadLogo} />
          <h5 className="display-5 ms-3">ANALISI LASER 2D</h5>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbarScroll" />

        <Navbar.Collapse id="navbarScroll">
          <Nav className="justify-content-end flex-grow-1 pe-5 gap-3 size-navlink">

            {/* Internal/Admin - Macro Sections */}
            {(role === "admin" || role === "internal") &&
              sectionsInternal.map(section => renderSection(section))
            }

            {/* Customer */}
            {role === "customer" &&
              sectionsCustomer.map(section => renderSection(section))
            }

            {/* Profile */}
            <NavDropdown title={<><FaUserCircle className="me-2" /> MyProfile</>}>
              <NavDropdown.Item onClick={handleSignOut}>
                Logout
              </NavDropdown.Item>

              <NavDropdown.Item as={NavLink} to="/change-password">
                {role === "customer" ? "Change Password" : "Cambio Password"}
              </NavDropdown.Item>

              {role === "admin" && (
                <>
                  <NavDropdown.Divider />
                  <NavDropdown.Item as={NavLink} to='/create-new-user'>
                    Creazione nuovo utente
                  </NavDropdown.Item>
                </>
              )}
            </NavDropdown>

          </Nav>
        </Navbar.Collapse>

      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
